import { TitleContainer } from "./styled";
import { Button} from 'antd';
import { PrinterFilled, ReloadOutlined } from '@ant-design/icons';
import ReactToPrint from 'react-to-print'

const ProgressSubHeader = (props) => {
    const { printRef, title, icon, style, printStyle, handleReloadData } = props

    return (
        <TitleContainer>
            <div style={{display: "flex", justifyContent:"space-between"}}>
                <div style={{...style, alignSelf:"center"}}>{icon}<span style={{fontFamily: '"Inter var", Roboto, Helvetica, Arial, sans-serif'}}>{title}</span></div>

                <div style={{alignSelf:"center", display: 'flex'}}>
                    <Button type="primary" shape="circle" icon={<ReloadOutlined />} size="middle" style={{marginRight: "8px"}} onClick={handleReloadData}></Button>
                    <ReactToPrint
                        trigger={() => <Button type="primary" shape="round" icon={<PrinterFilled />} size="middle">Print</Button>}
                        content={() => printRef.current}
                        pageStyle={printStyle}
                    />
                </div>
            </div>
        </TitleContainer>
    )
}

export default ProgressSubHeader;